import * as React from 'react';
import {
  makeStyles,
  tokens,
  Text,
  Button,
  Spinner,
} from '@fluentui/react-components';
import { useIntl } from 'react-intl';
import { Header } from '../components/Header';
import {
  syncStatusMessages,
  workspaceResolverMessages,
} from '../intl/messages';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: tokens.spacingHorizontalXXL,
    gap: tokens.spacingVerticalM,
    textAlign: 'center',
  },
  message: {
    color: tokens.colorNeutralForeground2,
  },
});

type Props = {
  status: 'idle' | 'resolving' | 'no-document' | 'error';
  errorMessage?: string | null;
  retry?: () => void;
};

export function WorkspaceStatusView({ status, errorMessage, retry }: Props) {
  const styles = useStyles();
  const intl = useIntl();

  const renderContent = () => {
    switch (status) {
      case 'idle':
      case 'resolving':
        return (
          <Spinner
            size="medium"
            label={intl.formatMessage(syncStatusMessages.resolving)}
            labelPosition="below"
          />
        );

      case 'no-document':
        return (
          <Text className={styles.message}>
            {intl.formatMessage(workspaceResolverMessages.openFromShowell)}
          </Text>
        );

      case 'error':
        return (
          <>
            <Text className={styles.message}>
              {errorMessage ||
                intl.formatMessage(workspaceResolverMessages.resolutionError)}
            </Text>
            {retry && (
              <Button appearance="primary" onClick={retry}>
                {intl.formatMessage(workspaceResolverMessages.retry)}
              </Button>
            )}
          </>
        );
    }
  };

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.content}>{renderContent()}</div>
    </div>
  );
}
